import React from "react"
import { Button, Modal, Typography } from "antd"
import { Logo } from "components/image/logo"
import { formatDate, formatMoney } from "utils";
import { businessName, businessDocument, businessAddress, businessAddressLine2, businessContact } from "config/business";

const { Text } = Typography;


const StatementReport = ({ data, componentRef, printShow, setPrintShow, handlePrint, sender }) => {

    const [pagedLines, setPagedLines] = React.useState([]);

    React.useEffect(() => {
            if(data?.statement){
                const statementCopy = structuredClone(data?.statement || []);
                const chuckedLines = chunkLines(statementCopy, 22);
                setPagedLines(chuckedLines);
            }
        }, [data])

    const chunkLines = (lines, chunkSize = 30) => {
        const pagedLines = [];
        for (let i = 0; i < lines.length; i += chunkSize) {
            const chunk = lines.slice(i, i + chunkSize);
            pagedLines.push(chunk);
        }
        return pagedLines;
    };

    const StatementTable = ({pages}) => (
        <>
            {pages && pages.length > 0 && pages.map((pageLines, pageIndex) => (
                <React.Fragment key={pageIndex}>
                    {pageIndex > 0 && <div style={{ pageBreakBefore: "always", marginTop: "25px" }} />}
                    <div className="table-detail" style={{ marginTop: 25 }}>
                        <table style={{ width: "100%", tableLayout: "fixed" }}>
                            <thead >
                                <tr >
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Data</Typography.Text></th>
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong ><p>Origem<br />Transação</p></Typography.Text></th>
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Status</Typography.Text></th>
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Valor</Typography.Text></th>
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Segmentação</Typography.Text></th>
                                    <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Cartão</Typography.Text></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ height: "15px" }}>
                                    <td colSpan={6} style={{ padding: 0 }}></td>
                                </tr>
                                {
                                    pageLines.map((entry, index) => {
                                        const registerValue = ((entry.reversal || entry.name === "Carga" || entry.name === "Estorno") ? "+" : "-") +
                                            entry.value
                                        return (
                                            <tr
                                                key={entry.id || index}
                                                style={{
                                                    borderBottom: "1px solid #eee",
                                                    pageBreakInside: "avoid"
                                                }}
                                            >
                                                <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }} >{formatDate(entry.date)}</Typography.Text></td>
                                                <td style={{ textAlign: "center" }} ><Typography.Text style={{ padding: "8px 5px", fontSize: "10px", padding: "0" }} >{entry.name}</Typography.Text></td>
                                                <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "9px", fontWeight: "bold", color: entry.declined ? "#ff4d4f" : entry.promise ? "#faad14" : "#52c41a" }}>{entry.promise
                                                    ? "PENDENTE"
                                                    : entry.declined
                                                        ? entry.declined.name.toUpperCase()
                                                        : "APROVADO"}</Typography.Text></td>
                                                <td style={{ textAlign: "center" }}><Typography.Text style={{
                                                    padding: "8px 5px", fontSize: "10px", color: registerValue > 0 ? "" : "red"
                                                }} >
                                                    {formatMoney(registerValue)}</Typography.Text></td>
                                                <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px", padding: "0" }} >{entry.nameBenefit}</Typography.Text></td>
                                                <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }}>{entry.cardNumber ? entry.cardNumber : ""}</Typography.Text></td>
                                            </tr>

                                        )
                                    })

                                }
                                <tr style={{ height: "15px" }}>
                                    <td colSpan={6} style={{ padding: 0 }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            ))}
        </>
    )

    return (
        <Modal
            width={1000}
            open={printShow}
            title="Extrato de Usuário"
            onCancel={() => setPrintShow(false)}
            footer={
                [
                    <Button key="submit" type="primary" loading={false} onClick={handlePrint}>
                        Imprimir
                    </Button>
                ]}
        >

            {
                (data?.statement || []).length > 0 &&
                <div ref={componentRef} className="print" style={{ alignItems:"center",justifyContent:"center",flexDirection:"column",display:"flex",padding: "30px" }} >
                    <div style={{ alignItems:"center",justifyContent:"center",flexDirection:"column",display:"flex",width: "100%" }} className="print-content">
                        <table style={{ width: "100%", marginBottom: "40px", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "50%", fontSize: "12px", color: "#666" }} className="smallInfos">
                                        <Text className="black">
                                            {formatDate(new Date())}
                                        </Text>
                                    </td>
                                    <td style={{ width: "50%", textAlign: "right", fontSize: "12px", fontWeight: "bold" }}>
                                        <Text className="black">
                                            Aly+
                                        </Text>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "50%", fontSize: "12px", color: "#666" }} className="smallInfos" >{"Emitido por: " + sender}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ paddingTop: "40px" }}>
                                        <Typography.Title level={2} style={{ margin: 0, fontSize: "24px" }}>
                                            Extrato do usuário
                                        </Typography.Title>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{ paddingTop: "8px" }}>
                                        <Typography.Title style={{ margin: 0, fontSize: "18px", fontWeight: "normal" }} level={3} >
                                            {(data?.user?.name || "")}
                                        </Typography.Title>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {(data?.balance?.details || []).length > 0 &&
                            <div className="table-detail" style={{ marginTop: 25 }}>
                                <table style={{ width: "100%", tableLayout: "fixed" }}>
                                    <thead >
                                        <tr >
                                            <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Segmentação</Typography.Text></th>
                                            <th ><Typography.Text style={{ padding: "10px 5px", textAlign: "center", fontSize: "10px", color: "#fff" }} strong >Saldo</Typography.Text></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={{ height: "15px" }}>
                                            <td colSpan={2} style={{ padding: 0 }}></td>
                                        </tr>
                                        {
                                            data.balance.details.map((entry, index) => {
                                                return (
                                                    <tr
                                                        key={entry.id || index}
                                                        style={{
                                                            borderBottom: "1px solid #eee",
                                                            pageBreakInside: "avoid"
                                                        }}
                                                    >
                                                        <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }} >{entry.nameBenefit}</Typography.Text></td>
                                                        <td style={{ textAlign: "center" }} ><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }} >{formatMoney(entry.balance)}</Typography.Text></td>
                                                    </tr>
                                                )
                                            })

                                        }
                                        <tr>
                                            <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }} strong >Total</Typography.Text></td>
                                            <td style={{ textAlign: "center" }}><Typography.Text style={{ padding: "8px 5px", fontSize: "10px" }} >{formatMoney(data.balance.balance)}</Typography.Text></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>}

                        {
                            <StatementTable pages={pagedLines} />
                        }
                    </div>
                    <div className="print-footer" style={{ pageBreakInside: "avoid" }}>
                        <div style={{ marginBottom: "15px" }}>
                            <Logo justify="flex-start" />
                        </div>
                        <div style={{width:"35%"}}></div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span style={{ fontSize: "10px", fontWeight: "bold" }}>{businessName()}</span>
                            <span style={{ fontSize: "10px" }}><strong>CNPJ:</strong> {businessDocument()}</span>
                            <span style={{ fontSize: "10px" }}>{businessAddress()}</span>
                            <span style={{ fontSize: "10px" }}>{businessAddressLine2()}</span>
                            <span style={{ fontSize: "10px" }}>{businessContact()}</span>
                        </div>
                    </div>
                </div>
            }
        </Modal>)
}
export { StatementReport }

